import {
  closestCenter,
  DndContext,
  DragEndEvent,
  PointerSensor,
  useSensor,
  useSensors,
} from '@dnd-kit/core';
import { restrictToVerticalAxis } from '@dnd-kit/modifiers';
import { SortableContext, verticalListSortingStrategy } from '@dnd-kit/sortable';
import { Table, TableBody, TableContainer, TableHead, TableRow } from '@mui/material';
import React from 'react';

import { StyledTableHeaderCell } from '../../../../theme/CustomComponents';
import { Question } from '../../../../Types/dealGPT';
import QuestionRow from './QuestionRow';

interface QuestionsTableProps {
  editable: boolean;
  reordering: boolean;
  questions: Question[];
  refetchQuestions: () => void;
  onNewQuestionSaved: () => void;
  handleDragEnd: (event: DragEndEvent) => void;
}

const QuestionsTable: React.FC<QuestionsTableProps> = ({
  editable,
  reordering,
  questions,
  refetchQuestions,
  onNewQuestionSaved,
  handleDragEnd,
}) => {
  const sensors = useSensors(useSensor(PointerSensor));

  const tableContent = (
    <TableContainer
      sx={{
        overflowX: 'auto',
        maxWidth: '1200px',
      }}
    >
      <Table stickyHeader size="small" sx={{ border: '1px solid rgb(244, 244, 244)' }}>
        <TableHead>
          <TableRow sx={{ th: { borderBottom: '2px solid rgb(244, 244, 244)' } }}>
            <StyledTableHeaderCell colSpan={editable ? 1 : 2}>Question</StyledTableHeaderCell>
            {editable && <StyledTableHeaderCell width="120px"></StyledTableHeaderCell>}
          </TableRow>
        </TableHead>
        <TableBody>
          {questions.map((question) => (
            <QuestionRow
              key={question.id}
              reordering={reordering}
              editable={editable}
              question={question}
              onNewQuestionSaved={onNewQuestionSaved}
              refetchQuestions={refetchQuestions}
            />
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );

  if (!reordering) return tableContent;

  return (
    <DndContext
      sensors={sensors}
      collisionDetection={closestCenter}
      onDragEnd={handleDragEnd}
      modifiers={[restrictToVerticalAxis]}
    >
      <SortableContext items={questions.map((q) => q.id)} strategy={verticalListSortingStrategy}>
        {tableContent}
      </SortableContext>
    </DndContext>
  );
};

export default QuestionsTable;
